import { _ } from "libs";

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Avatar from "./avatar";
import UserContext from "../contexts/userContext";
import LoginButton from "./club/bookingWizard/loginButton";

const NavbarWidget = ({
	authenticated,
	clubName,
	canGoBack,
	onLoginButtonClicked,
	onRegisterButtonClicked,
	hash,
}: {
	authenticated: boolean;
	clubName?: string;
	canGoBack: boolean;
	onLoginButtonClicked;
	onRegisterButtonClicked;
	hash?: string;
}) => {
	const { profile } = useContext(UserContext);

	return (
		<header className="header">
			<nav>
				<div className="main">
					<Link to="/" className="logo" target="_blank">GotCourts</Link>
					{clubName && (
						<div className="club">
							{canGoBack && <Link className="back" to={"/clubsWidget" + hash} />}
							<div className="clubName">{clubName}</div>
						</div>
					)}
				</div>
				<div className="info">
					{authenticated ? (
						<>
							{profile ? (
								<div className="user">
									<Avatar photoUrl={profile.photoUrl} size="thumb3" />
									<div className="name">{profile.firstName}</div>
								</div>
							) : null}
							<div className="actions">
								<Link to="/" target="_blank" className="button secondaryButton">
									{_("nav.goToApp")}
								</Link>
							</div>
						</>
					) : (
						<div className="actions">
							<LoginButton className="button secondaryButton" onClick={onLoginButtonClicked} />
							<button className="button primaryButton" onClick={onRegisterButtonClicked}>
								{_("nav.create_account")}
							</button>
						</div>
					)}
				</div>
			</nav>
		</header>
	);
};

export default NavbarWidget;
